import { Category } from "@/apps/shared/catalog/core/domain/Category/Category";
import { Identifier } from "@/apps/shared/catalog/core/domain/Category/Identifier";
import { Category as LegacyCategory } from "@/core/models/category";

export const legacyCategoriesToModel = (legacyCategories: LegacyCategory[]): Category[] => {
  const categories = legacyCategories.map((category: LegacyCategory) => legacyCategoryToModel(category));

  categories.forEach((category) => {
    const legacyParentCategory = legacyCategories.find((c) => c.id === category.id)?.parentCategory;

    if (legacyParentCategory) {
      category.parent = new Category(legacyParentCategory.id, legacyParentCategory.label, null, "", []);
    }
  });

  return categories;
};

export const legacyCategoryToModel = (legacyCategory: LegacyCategory): Category => {
  const children = legacyCategory.children?.map((child: LegacyCategory) => legacyCategoryToModel(child)) ?? [];

  return new Category(
    legacyCategory.id,
    legacyCategory.label,
    new Identifier(legacyCategory.identifier),
    legacyCategory.childrenDescription,
    children
  );
};
